document.addEventListener('DOMContentLoaded', function() {
  const lang = document.documentElement.lang;
  
  if (lang === 'fr') {
    // Run immediately
    translateContent();
    
    // Also run after a short delay to catch dynamically loaded content
    setTimeout(translateContent, 500);
    setTimeout(translateContent, 1000);
  }
  
  function translateContent() {
    // Translate "All Products" heading
    document.querySelectorAll('h1, h2, h3').forEach(function(heading) {
      const text = heading.textContent.trim();
      if (text === 'All Products') {
        heading.textContent = 'Tous les produits';
      }
    });
    
    // Translate the description
    document.querySelectorAll('p').forEach(function(p) {
      if (p.textContent.trim() === 'Browse our complete selection of fresh, healthy ready-to-eat meals and bundles.') {
        p.textContent = 'Parcourez notre sélection complète de repas prêts-à-manger frais et sains et de forfaits.';
      }
    });
  }
});

